import { Directive, ElementRef, Renderer2, HostListener } from '@angular/core';

@Directive({
  selector: '[ssToggleSubmenu]',
  standalone: false
})
export class ToggleSubmenuDirective {
  constructor(
    private el: ElementRef,
    private render: Renderer2
  ) { }

  @HostListener('click', ['$event'])
  public onMouseClick(event?: Event): void {
    const target = event?.target as HTMLElement | null;
    if (target && target.closest('.ss-side-submenu')) {
      return;
    }

    const host = this.el.nativeElement as HTMLElement;
    const submenu = host.querySelector('.ss-side-submenu');
    const trigger = host.querySelector('.ss-side-menu__item');

    if (!submenu) { return; }

    if (submenu.classList.contains('is-open')) {
      this.render.removeClass(submenu, 'is-open');
      this.render.removeClass(host, 'is-open');
      if (trigger) {
        this.render.setAttribute(trigger, 'aria-expanded', 'false');
      }
      return;
    }

    const list = document.querySelectorAll('.ss-side-submenu');
    for (let i = 0; i < list.length; i++) {
      list[i].classList.remove('is-open');
      const parent = list[i].closest('[ssToggleSubmenu]');
      if (parent) {
        parent.classList.remove('is-open');
        const btn = parent.querySelector('.ss-side-menu__item');
        if (btn) {
          btn.setAttribute('aria-expanded', 'false');
        }
      }
    }

    this.render.addClass(submenu, 'is-open');
    this.render.addClass(host, 'is-open');
    if (trigger) {
      this.render.setAttribute(trigger, 'aria-expanded', 'true');
    }
  }
}
